import ActionText from '../../core/ActionText';
import PagingFilter from '../../core/PagingFilter';
import Grid from '@material-ui/core/Grid';
import IconButton from '@material-ui/core/IconButton';
import { withStyles } from '@material-ui/core/styles';
import Tooltip from '@material-ui/core/Tooltip';
import Typography from '@material-ui/core/Typography';
import BubbleChartIcon from '@material-ui/icons/BubbleChart';
import GrainIcon from '@material-ui/icons/Grain';
import ReorderIcon from '@material-ui/icons/Reorder';
import SyncIcon from '@material-ui/icons/Sync';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { ENTITLEMENTS as APPENTITLEMENTS } from '../../core/utils/constants';
import { APPLICATION_PATHS, ENTITLEMENTS } from '../../application-core/constants';
import AreYouSure from '../../core/AreYouSure';
import ComponentListItem from '../../core/ComponentListItem';
import Errored from '../../core/Errored';
import LoadingButton from '../../core/LoadingButton';
import MenuSelector from '../../core/MenuSelector';
import PrimaryButton from '../../core/PrimaryButton';
import ComponentDialog from '../../core/project/ComponentDialog';
import SecondaryButton from '../../core/SecondaryButton';
import { globalStyles as styles } from '../../core/style/gstheme';
import SynchronisationDialog from '../../core/synchronisation/SynchronisationDialog';
import { makeCancelable, sortObjects } from '../../core/utils/utils';
import GS from '../../grafsync/grafsync';
import ProjectConceptSearch from '../taxonomies/ProjectConceptSearch';
import TaxonomyAreYouSure from './TaxonomyAreYouSure';
import FindIdentifierDialog from '../../core/FindIdentifierDialog';

class VocabularyProjectDetail extends Component {

  constructor(props) {
    super(props);
    this.state = {
      syncProject: false,
      syncItems: [],
      integrations: [],
      workflowData: [],
      deletions: 0,
      pendingDeletions: 0,
      isErrored: null,
      taxonomyFilter: "",
      collectionFilter: "",
      areYouSure: false,
      componentChanges: [],
      option: "",
      processingComplete: false,
      areYouSureCollection: false,
      areYouSureToPurge: false,
      additionalMessages: [],
      componentId: null,
      processing: false,
      isLoadingIntegrations: false,
      link: null
    };
    this.cancellable = null;
    this.cancellable1 = null;
    this.cancellable2 = null;
  }

  checkIfSure = (componentId, link) => (ev) => {
    this.setState({ areYouSure: true, componentId, link });
    ev.preventDefault();
    ev.stopPropagation();
  };

  checkIfCollectionSure = (componentId, link, messages) => (ev) => {
    this.setState({ areYouSureCollection: true, componentId, link, additionalMessages: messages });
    ev.preventDefault();
    ev.stopPropagation();
  };

  onComponent = async () => {
    this.setState({ areYouSure: false, areYouSureCollection: false });
    try {
      await GS.waitForEditsToClear();
      GS.operate("taxonomyonlydeletion", this.props.graph, {
        resource: this.state.componentId
      });
    }
    catch (e) {
      this.setState({ isErrored: e, isLoadingIntegrations: false });
    }
  };

  onFull = async () => {
    this.setState({ areYouSure: false });
    try {
      await GS.waitForEditsToClear();
      GS.operate("fulltaxonomydeletion", this.props.graph, {
        resource: this.state.componentId
      });
    }
    catch (e) {
      if (this.cancellable && this.cancellable.isCancelled()) return;
      this.setState({ isErrored: e, isLoadingIntegrations: false });
    }
  };

  onNotSure = () => this.setState({ areYouSure: false, areYouSureCollection: false, areYouSureToPurge: false });

  checkIfSureToPurge = () => this.setState({ areYouSureToPurge: true });

  syncProject = async () => {
    this.setState({ isLoadingIntegrations: true }, async () => {
      try {
        GS.handle("sync-project");
        const integrations = await this.doGetIntegrations().promise;
        const { taxonomies, collections } = this.props;
        if (this.cancellable && this.cancellable.isCancelled()) return;
        const workflowDataResults = taxonomies && taxonomies.length > 0 ?
          await this.loadData("approvalstatistics").promise
          :
          [];
        if (this.cancellable && this.cancellable.isCancelled()) return;
        const workflowData = workflowDataResults.graph || [];
        const sortedIntegrations = sortObjects(integrations, "label", "en");
        const taxonomyList = taxonomies ? taxonomies.map((taxonomy) => taxonomy.id) : [];
        const collectionList = collections ? collections.map((collection) => collection.id) : [];
        this.setState({
          integrations: sortedIntegrations,
          isLoadingIntegrations: false,
          workflowData,
          syncProject: true,
          syncItems: [...taxonomyList, ...collectionList]
        });
      }
      catch (e) {
        if (!this.cancellable || (this.cancellable && !this.cancellable.isCancelled())) {
          this.setState({ isErrored: e, isLoadingIntegrations: false });
        }
      }
    });
  };

  loadData(exportName) {
    this.cancellable = makeCancelable(GS.export(exportName, this.props.project, this.props.graph));
    return this.cancellable;
  }

  doGetIntegrations() {
    this.cancellable = makeCancelable(GS.integrations());
    return this.cancellable;
  }

  syncItem = (ev, id) => {
    ev.preventDefault();
    ev.stopPropagation();
    let newSyncItems = [...this.state.syncItems];
    if (newSyncItems.includes(id)) {
      newSyncItems.splice(newSyncItems.indexOf(id), 1);
    }
    else {
      newSyncItems.push(id);
    }
    this.setState({ syncItems: newSyncItems });
  };

  cancelSyncProject = () => this.setState({
    syncProject: false,
    option: "",
    componentChanges: [],
    pendingDeletions: 0,
    deletions: 0
  });

  handleIntegrationChange = async (option) => {
    this.setState({ option, loadingChanges: true }, async () => {
      try {
        const changes = await this.doSynchroniseChanges(option).promise;
        if (this.cancellable1 && this.cancellable1.isCancelled()) return;
        const deletions = await this.doSynchroniseDeletions(option).promise;
        if (this.cancellable1 && this.cancellable1.isCancelled()) return;
        this.setState({
          componentChanges: changes,
          loadingChanges: false,
          mostRecentTime: deletions.mostRecentTime,
          deletions: deletions.resourceCount,
          pendingDeletions: deletions.pendingResourceCount
        });
      }
      catch (e) {
        if (!this.cancellable1 || (this.cancellable1 && !this.cancellable1.isCancelled())) {
          this.setState({ isErrored: e, syncProject: false, option: "", loadingChanges: false });
        }
      }
    });
  };

  doSynchroniseChanges(integration) {
    this.cancellable1 = makeCancelable(GS.synchroniseChanges(integration, this.props.graph));
    return this.cancellable1;
  }

  doSynchroniseDeletions(integration) {
    this.cancellable1 = makeCancelable(GS.synchroniseDeletions(integration, this.props.graph));
    return this.cancellable1;
  }

  clearError = () => this.setState({ isErrored: false });

  purge = async () => {
    try {
      await GS.waitForEditsToClear();
      GS.operate("floatingcleanup", this.props.graph);
    }
    catch (e) {
      this.setState({ isErrored: e, isLoadingIntegrations: false });
    }
  };

  clearSyncItems = () => this.setState({ syncItems: [] });

  synchronise = async () => {
    this.setState({ processing: true, processingComplete: false }, async () => {
      this.doSynchronise()
        .promise
        .then(() => {
          this.setState({
            processing: false,
            processingComplete: true,
            syncProject: false,
            deletions: 0,
            pendingDeletions: 0,
            componentChanges: [],
            option: ""
          });
        })
        .catch((e) => {
          if (this.cancellable2 && !this.cancellable2.isCancelled()) this.setState({
            processing: false,
            isErrored: e,
            syncProject: false,
            option: "",
            componentChanges: [],
            pendingDeletions: 0,
            deletions: 0
          });
        });
    });
  };

  doSynchronise() {
    this.cancellable2 = makeCancelable(GS.synchronise(this.state.option, this.props.graph, this.state.syncItems));
    return this.cancellable2;
  }

  completeProcessing = () => this.setState({
    syncProject: false,
    processingComplete: false
  });

  componentWillUnmount() {
    if (this.cancellable) this.cancellable.cancel();
    if (this.cancellable1) this.cancellable1.cancel();
    if (this.cancellable2) this.cancellable2.cancel();
  }

  handleTaxonomyFilterChange = (filter) => this.setState({ taxonomyFilter: filter });

  handleCollectionFilterChange = (filter) => this.setState({ collectionFilter: filter });

  render() {

    const { classes, project, monitorLinkUpdate, entitlements, skosXL } = this.props;
    const { areYouSure, areYouSureToPurge, areYouSureCollection, additionalMessages, componentChanges, option, processing,
      taxonomyFilter, collectionFilter, mostRecentTime, workflowData, isLoadingIntegrations,
      syncProject, syncItems, integrations, isErrored, processingComplete, deletions, pendingDeletions, loadingChanges } = this.state;
    const defaultLang = this.props.data.defaultLang;
    const { taxonomies, collections, addCollection, addTaxonomy, graph } = this.props;
    const integrationList = integrations.map(integration => ({
      value: integration.id,
      label: integration.label["en"]
    }));

    let unapprovedInfo = [];
    if (syncProject && !isLoadingIntegrations && taxonomies) {
      unapprovedInfo = taxonomies.map(t => {
        const wt = workflowData.find(wf => wf.id === t.id);
        if (wt) {
          const ws = workflowData.find(wf => wf.id === wt.viewStatistic[0]);
          return ws.viewCount;
        }
        else return 0;
      });
    }

    if (isErrored) return <Errored dataTest="vp-error" data={isErrored} clearError={this.clearError} />;
    if (processing || processingComplete) return <SynchronisationDialog processing={processing} onExit={this.completeProcessing} />;

    return (
      <React.Fragment>
        <Grid container>
          <Grid item xs={12} className={classes.componentContainer} style={{ paddingBottom: 0 }}>
            {syncProject ?
              <Grid container spacing={0}>
                <Grid item xs={2}>
                  <div style={{ marginTop: 4, marginBottom: 6 }}>
                    <MenuSelector
                      autoFocus
                      hintWord="Select an integration"
                      hintPrefix={false}
                      dataTest="integration-type"
                      handleChange={this.handleIntegrationChange}
                      options={integrationList} />
                  </div>
                </Grid>
                <Grid item xs={10}>
                  <span style={{ paddingLeft: 24 }}>
                    <SecondaryButton dataTest="cancel-sync-project" onClick={this.cancelSyncProject}>Cancel</SecondaryButton>
                  </span>
                  <span>
                    {((taxonomies && taxonomies.length > 0) || (collections && collections.length > 0)) &&
                      <span style={{ paddingLeft: 24 }}>
                        <SecondaryButton dataTest="clear" onClick={this.clearSyncItems}>Deselect All</SecondaryButton>
                      </span>
                    }
                  </span>
                  {option &&
                    <span style={{ paddingLeft: 24 }}>
                      {processing ?
                        <LoadingButton disabled />
                        :
                        <PrimaryButton dataTest="sync" onClick={this.synchronise}>Synchronise</PrimaryButton>
                      }
                    </span>
                  }
                </Grid>
                {syncProject && option && mostRecentTime === 0 && <Typography data-test="not-run" variant="body2">This integration has not been run on this project.</Typography>}
                {syncProject && option && mostRecentTime !== 0 && <Typography data-test="last-run" variant="body2">This integration wast last run at {(new Date(mostRecentTime)).toLocaleString()}.</Typography>}
                {syncProject && option && <Grid item xs={12}>
                  {loadingChanges ?
                    <Typography paragraph variant="body2">Gathering information...</Typography>
                    :
                    <React.Fragment>
                      <Typography data-test="deletions-since-last" style={{ color: '#CA4F0C' }} variant="body2">{deletions} deletion(s) since last run.</Typography>
                      <Typography paragraph variant="caption">Deletions are included in synchronisations.</Typography>
                      {pendingDeletions > 0 &&
                        <div>
                          <Typography data-test="pending-since-last" style={{ color: '#CA4F0C' }} variant="body2">{pendingDeletions} resource(s) pending deletion.</Typography>
                          <Typography paragraph variant="caption">Note that pending deleted resources are not included in synchronisations. After a period of time pending deletions are made permanent and will then appear in the deletions count.</Typography>
                        </div>
                      }
                    </React.Fragment>
                  }
                </Grid>
                }
              </Grid>
              :
              <Grid container spacing={0}>
                <Grid item xs={6}>
                  <ProjectConceptSearch skosXL={skosXL} defaultLang={defaultLang} project={project} graph={graph} />
                </Grid>
                <Grid item xs={6} style={{ textAlign: 'right' }}>
                  <FindIdentifierDialog
                    graph={graph}
                    defaultLang={defaultLang}
                    componentProps={["inScheme"]}
                    project={project} />
                  {entitlements.includes(APPENTITLEMENTS.SYNCHRONISE_DATA) &&
                    <Tooltip title="Synchronise project">
                      <IconButton aria-label="Synchronise project" data-test="sync-project" size="small" onClick={this.syncProject}>
                        <SyncIcon />
                      </IconButton>
                    </Tooltip>
                  }
                </Grid>
              </Grid>
            }
          </Grid>
          <Grid item xs={12} md={6} className={classes.componentContainer}>
            <div className={classes.componentContainerContent}>
              <Grid container spacing={0}>
                <Grid item xs={12} sm={4}>
                  <Typography variant="h6" className={classes.mainHeading}>
                    <span>Taxonomies</span>
                    {taxonomies && taxonomies.length > 5 &&
                      <span style={{ color: '#888' }}> ({taxonomies.length})</span>
                    }
                  </Typography>
                  {taxonomies && taxonomies.length > 5 &&
                    <div style={{ width: 200 }} data-test="taxonomy-filter">
                      <PagingFilter
                        autoFocus={false}
                        handleFilterChange={this.handleTaxonomyFilterChange}
                        placeholder="Filter taxonomies"
                        text={""}
                        maxLength={50} />
                    </div>
                  }
                </Grid>
                <Grid item xs={12} sm={8} style={{ textAlign: 'right' }}>
                  {!syncProject && entitlements && entitlements.includes(ENTITLEMENTS.CREATE_TAXONOMY) &&
                    <ComponentDialog
                      dataTest="add-taxonomy"
                      slashHash={true}
                      useXL={skosXL}
                      allowCounter={true}
                      showSecondaryCounter={true}
                      existingComponents={[].concat(taxonomies, collections)}
                      lang={defaultLang}
                      project={project}
                      onAddComponent={addTaxonomy}
                      label="Create Taxonomy" />
                  }
                </Grid>
              </Grid>
              {taxonomies && taxonomies.length > 0 ?
                <div data-test="taxonomy-components" className={classes.componentList}>
                  {taxonomies && taxonomies.map((taxonomy, index) =>
                    <ComponentListItem
                      dataTest={taxonomy.id}
                      id={taxonomy.id}
                      graph={graph}
                      additionalDisplay={syncProject && !isLoadingIntegrations && unapprovedInfo[index] !== 0 ?
                        <Typography
                          variant="body2"
                          data-test="unapproved-resources"
                          style={{ color: '#CA4F0C' }}
                        >
                          <span>This taxonomy has {unapprovedInfo[index]} unapproved resources.</span>
                        </Typography>
                        :
                        null
                      }
                      changes={syncProject && !loadingChanges ? componentChanges.find(change => change.component === taxonomy.id) : null}
                      updateEvent={monitorLinkUpdate}
                      key={taxonomy.id}
                      defaultLang={defaultLang}
                      sync={syncProject}
                      filter={taxonomyFilter}
                      selected={syncItems.includes(taxonomy.id)}
                      onSelect={this.syncItem}
                      entitlements={entitlements}
                      accessEntitlements={[ENTITLEMENTS.VIEW_TAXONOMY]}
                      entitlement={ENTITLEMENTS.CREATE_TAXONOMY}
                      link={APPLICATION_PATHS.TAXONOMY_MANAGER + "/project/taxonomy#project=" + project + "&taxonomy=" + taxonomy.id}
                      onDelete={this.checkIfSure(taxonomy.id, APPLICATION_PATHS.TAXONOMY_MANAGER + '/project/detail#project=' + project)}
                      avatar={<BubbleChartIcon fontSize="small" />}
                    />
                  )}
                </div>
                :
                <ActionText dataTest="create-taxonomy" offset="100px">Create or import a taxonomy to get started.</ActionText>
              }
            </div>
          </Grid>
          <Grid item xs={12} md={6} className={classes.componentContainer}>
            <div className={classes.componentContainerContent}>
              <Grid container spacing={0}>
                <Grid item xs={12} sm={4}>
                  <Typography variant="h6" className={classes.mainHeading}>
                    <span>Collections</span>
                    {collections && collections.length > 5 &&
                      <span style={{ color: '#888' }}> ({collections.length})</span>
                    }
                  </Typography>
                  {collections && collections.length > 5 &&
                    <div style={{ width: 200 }} data-test="collections-filter">
                      <PagingFilter
                        autoFocus={false}
                        handleFilterChange={this.handleCollectionFilterChange}
                        placeholder="Filter collections"
                        text={collectionFilter}
                        maxLength={50} />
                    </div>
                  }
                </Grid>
                <Grid item xs={12} sm={8} style={{ textAlign: 'right' }}>
                  {!syncProject && entitlements && entitlements.includes(ENTITLEMENTS.CREATE_TAXONOMY) &&
                    <ComponentDialog
                      slashHash={false}
                      dataTest="add-collection"
                      lang={defaultLang}
                      existingComponents={[].concat(taxonomies, collections)}
                      order={true}
                      project={project}
                      onAddComponent={addCollection}
                      label="Create Collection" />
                  }
                </Grid>
              </Grid>
              <div data-test="collection-components" className={classes.componentList}>
                {collections && collections.map((collection) =>
                  <ComponentListItem
                    dataTest={collection.id}
                    id={collection.id}
                    changes={syncProject && !loadingChanges ? componentChanges.find(change => change.component === collection.id) : null}
                    updateEvent={monitorLinkUpdate}
                    graph={graph}
                    key={collection.id}
                    defaultLang={defaultLang}
                    sync={syncProject}
                    filter={collectionFilter}
                    selected={syncItems.includes(collection.id)}
                    onSelect={this.syncItem}
                    entitlements={entitlements}
                    accessEntitlements={[ENTITLEMENTS.TAXONOMY]}
                    entitlement={ENTITLEMENTS.CREATE_TAXONOMY}
                    link={APPLICATION_PATHS.TAXONOMY_MANAGER + "/project/collection#project=" + project + "&collection=" + collection.id}
                    onDelete={this.checkIfCollectionSure(collection.id,
                      APPLICATION_PATHS.TAXONOMY_MANAGER + '/project/detail#project=' + project,
                      ["Do you really want to delete this collection?"])}
                    avatar={collection.type.includes("OrderedCollection") ?
                      <ReorderIcon fontSize="small" />
                      :
                      <GrainIcon fontSize="small" />
                    }
                  />
                )}
              </div>
            </div>
          </Grid>
          {entitlements && entitlements.includes(ENTITLEMENTS.CLEAR_FLOATING_ITEMS) && !syncProject &&
            <Grid item xs={4}>
              <div style={{ marginBottom: 24 }}>
                <SecondaryButton dataTest="purge-project" onClick={this.checkIfSureToPurge}>Purge Project</SecondaryButton>
              </div>
            </Grid>
          }
        </Grid>
        {areYouSure && <TaxonomyAreYouSure onFull={this.onFull} onTaxonomy={this.onComponent} onNotSure={this.onNotSure} />}
        {areYouSureCollection && <AreYouSure onSure={this.onComponent} onNotSure={this.onNotSure} message={additionalMessages} />}
        {areYouSureToPurge && <AreYouSure
          onSure={this.purge}
          onNotSure={this.onNotSure}
          message={[
            "Purging a project removes concepts and labels that are free-floating (not in any scheme) and which are not a member of a collection, nor a top concept, nor a narrower concept of another that is in a scheme.",
            "Note that no history is recorded for batch operations such as this.",
            "Whilst this is happening the project will be locked and no edits will be permitted on the project but the operation should not take long to complete."
          ]} />}
      </React.Fragment>
    );
  }
}

VocabularyProjectDetail.propTypes = {
  classes: PropTypes.object.isRequired,
  project: PropTypes.string.isRequired,
  addTaxonomy: PropTypes.func.isRequired,
  addCollection: PropTypes.func.isRequired,
  onDeleteComponent: PropTypes.func.isRequired,
  entitlements: PropTypes.array,
  monitorLinkUpdate: PropTypes.func.isRequired,
  collections: PropTypes.array,
  skosXL: PropTypes.bool,
  data: PropTypes.object.isRequired,
  graph: PropTypes.string.isRequired,
  taxonomies: PropTypes.array
};

export default withStyles(styles)(VocabularyProjectDetail);